export default __webpack_public_path__ + "static/media/uiTransition.6e77e566.mp3";